import { useMemo } from "react";
import { nostojs } from "@nosto/nosto-js";

import { type CartLine } from "types/cart";

export const useNostoAnalytics = () =>
  useMemo(() => {
    const trackHomepageView = () => {
      nostojs((api) => {
        api.defaultSession().viewFrontPage().load();
      });
    };

    const trackProductPageView = (productId: string) => {
      nostojs((api) => {
        api.defaultSession().viewProduct(productId).load();
      });
    };

    const trackCollectionPageView = (title: string) => {
      nostojs((api) => {
        // Set page type as category
        api.setTaggingProvider("pageType", "category");
        // Set category metadata
        api.setTaggingProvider("categories", [title]);
        api.defaultSession().viewCategory(title).load();
      });
    };

    const trackOtherPageView = () => {
      nostojs((api) => {
        api.defaultSession().viewOther().load();
      });
    };

    const trackSearch = (searchQuery: string) => {
      nostojs((api) => {
        api.defaultSession().viewSearch(searchQuery).load();
      });
    };

    const trackCart = (cartLines?: CartLine[]) => {
      if (!cartLines) return;

      nostojs((api) => {
        api
          .defaultSession()
          .setCart({
            items: cartLines.map((line) => ({
              product_id: line.merchandise.product.id.replace(
                "gid://shopify/Product/",
                "",
              ),
              sku_id: line.merchandise.id.replace(
                "gid://shopify/ProductVariant/",
                "",
              ),
              quantity: line.quantity,
              name: line.merchandise.product.title,
              unit_price: Number(line.custom.price.amount),
              price_currency_code: line.custom.price.currencyCode,
            })),
          })
          .viewCart()
          .update();
      });
    };

    return {
      trackCart,
      trackCollectionPageView,
      trackHomepageView,
      trackOtherPageView,
      trackProductPageView,
      trackSearch,
    };
  }, []);
